import React from "react";

import { Skeleton } from "antd";

import { BlockSkeletonProps, BlockSkeletonType } from "./blockSkeleton.model";
import { useMediaQuery } from "@companion-core/web/src/Utilities/mediaQuery";
import { SkeletonCard } from "@companion-core/shared/app/Components/Cards/SkeletonCard/SkeletonCard";

import "@companion-core/web/src/Assets/Styles/scss/skeletons.scss";

const BannerSkeleton = () => {
  return <Skeleton.Image className="skeletons__banner" active />;
};

const DetailSkeleton = () => {
  return (
    <>
      <BannerSkeleton />
      <div className="skeletons__detail-body">
        <Skeleton active />
        <Skeleton active />
      </div>
    </>
  );
};

const ButtonListSkeleton = () => {
  return (
    <div className="skeletons__button-list">
      <Skeleton.Node className="skeletons__button-list-title" active />
      <div className="skeletons__button-list-buttons">
        <Skeleton.Button active />
        <Skeleton.Button active />
      </div>
    </div>
  );
};

const PostListSkeleton = () => {
  return (
    <div className="skeletons__post-list">
      <div className="skeletons__post-list-section">
        <Skeleton.Image active />
        <div className="skeletons__post-list-text">
          <Skeleton active />
          <Skeleton active />
          <Skeleton active />
        </div>
      </div>
    </div>
  );
};

const ListSkeleton = () => {
  const isMobileSize = useMediaQuery("(max-width: 768px)");

  return (
    <div className="skeletons__list">
      <Skeleton.Node className="skeletons__list-title" active />
      <div className="skeletons__list-cards">
        {isMobileSize ? (
          <SkeletonCard />
        ) : (
          <>
            <SkeletonCard />
            <SkeletonCard />
            <SkeletonCard />
          </>
        )}
      </div>
    </div>
  );
};

const PictureListSkeleton = () => {
  const isMobileSize = useMediaQuery("(max-width: 768px)");

  return (
    <div className="skeletons__picture-list">
      <Skeleton active className="skeletons__picture-list-text" />
      {isMobileSize ? (
        <Skeleton.Image active className="skeletons__picture-list-card" />
      ) : (
        <div className="skeletons__picture-list-cards">
          <Skeleton.Image active className="skeletons__picture-list-card" />
          <Skeleton.Image active className="skeletons__picture-list-card" />
          <Skeleton.Image active className="skeletons__picture-list-card" />
        </div>
      )}
    </div>
  );
};

const GeolocationSkeleton = () => {
  const isMobileSize = useMediaQuery("(max-width: 768px)");
  return (
    <div className="skeletons__geolocation">
      {isMobileSize ? (
        <Skeleton.Image active className="skeletons__geolocation-image" />
      ) : (
        <>
          <Skeleton.Image active className="skeletons__geolocation-image" />
          <Skeleton active className="skeletons__geolocation-text" />
        </>
      )}
    </div>
  );
};

const Skeletons: Record<BlockSkeletonType, React.JSX.Element> = {
  "button-list": <ButtonListSkeleton />,
  "card-member": <BannerSkeleton />,
  "detail": <DetailSkeleton />,
  "header-visual": <BannerSkeleton />,
  "picture-list": <PictureListSkeleton />,
  "post-list": <PostListSkeleton />,
  "post-list-journey": <PostListSkeleton />,
  "push-notification": <BannerSkeleton />,
  newsletter: <BannerSkeleton />,
  geolocation: <GeolocationSkeleton />,
  header: <BannerSkeleton />,
  list: <ListSkeleton />,
  selection: <ListSkeleton />,
  tab: <></>,
  universe: <ListSkeleton />,
};

export const BlockSkeleton = ({ type }: BlockSkeletonProps) => {
  return Skeletons[type];
};
